import styled from 'styled-components';

import { Div } from 'common/styles/oc-styled-components';
import { Icon } from 'opencare-crown';

import {
  BREAKPOINTS,
  colors,
} from '../../../../../common/styles/style-constants';
import { PrimaryButton } from '../../../../common/styled-components';

export const FormItemWrapper = styled.div`
  width: ${props => props.width || '100%'};
  position: relative;
`;

export const Input = styled.input`
  font-size: 16px;
  font-weight: 600;
  color: ${colors.gray9};
  width: 100%;
  height: auto;
  padding: 15px;
  margin-top: 12px;
  border-radius: 10px;
  border: 1px solid ${colors.gray6};
  word-break: normal;

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    padding: 8px 15px;
  }

  &:active,
  &:focus {
    border-color: ${colors.blue};
    box-shadow: 0 0 3px ${colors.blue};
    outline: none !important;
  }

  &:hover {
    border-color: ${colors.blue};
    box-shadow: inset 0px 2px 3px rgba(0, 0, 0, 0.05);
  }

  &::placeholder {
    color: ${colors.gray6};
  }
`;

export const InputError = styled.p`
  font-size: ${props => props.fontSize || '14px'};
  width: 100%;
  text-align: initial;
  /* font-style: italic; */
  padding: ${props => props.padding || '2px 10px'};
  color: ${colors.coral5};
  line-height: 20px;
  margin: ${props => props.margin};
`;

export const BadgeWrapper = styled(Div)`
  padding: 10px 5px;
`;
export const IconContainer = styled(Div)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
`;

export const CheckCircleIcon = styled(Icon)`
  font-size: 40px;
  & svg {
    color: ${colors.sage6};
  }
`;

export const BadgeButton = styled(PrimaryButton)`
  margin-top: 20px;
  font-size: 18px;
`;
